// @ts-check
import { Component } from '@verndale/core';
import SiteSelector from './header/site-selector';
import PrimaryNav from './header/primary-nav';
import Search from './header/search';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $siteSelector: this.el.querySelector('.site-selector'),
      $primaryNav: this.el.querySelector('.primary-nav'),
      $search: this.el.querySelectorAll('.header-search')
    };

    this.siteSelector = new SiteSelector(this.dom.$siteSelector);
    this.primaryNav = new PrimaryNav(this.dom.$primaryNav);
    this.dom.$search.forEach((search) => new Search(search));
  }
}

export default Module;
